import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaDownload, FaEdit, FaBook, FaGithub, FaDiscord, FaLayerGroup } from 'react-icons/fa';
import './Navbar.scss';
import logo from '../../images/faviconBlank.png';

export default function NavbarComponent({ EXTERNAL_LINKS, setToggleHamburger, toggleHamburger, activeLink, setActiveLink }) {
  const navigate = useNavigate();
  const [isColourPopupOpen, setIsColourPopupOpen] = useState(false);

  const redirectToPage = (link) => {
    setActiveLink(link);
    navigate(link);
  };

  const handleLogoClick = () => {
    const atTop = window.scrollY === 0;
  
    if (activeLink !== 'home' && atTop) {
      redirectToPage('home');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleToggleHamburger = () => {
    setToggleHamburger(!toggleHamburger);
  };
  const colourPopup = (
    <div className="navbar-colour-popup">
            <h4 style={{ background: 'linear-gradient(to right, #ff0000, #0000ff)', color: 'transparent', WebkitBackgroundClip: 'text' }}>
        &lt;Gradient:#ff0000:#0000ff&gt;
      </h4>
      <h4>
        <span style={{ color: '#FF5555' }}>&lt;</span>
        <span style={{ color: '#FF5555' }}>R</span>
        <span style={{ color: '#FFAA00' }}>a</span>
        <span style={{ color: '#FFFF55' }}>i</span>
        <span style={{ color: '#55FF55' }}>n</span>
        <span style={{ color: '#55FFFF' }}>b</span>
        <span style={{ color: '#5555FF' }}>o</span>
        <span style={{ color: '#FF55FF' }}>w</span>
        <span style={{ color: '#FF5555' }}>&gt;</span>
      </h4>
      <h4 style={{ color: '#EC4E2C' }}>&lt;#ec4e2c&gt;</h4>
      <h4 style={{ color: '#0000AA' }}>&lt;Dark_Blue&gt;</h4>
      <h4 style={{ color: '#00AA00' }}>&lt;Dark_Green&gt;</h4>
      <h4 style={{ color: '#00AAAA' }}>&lt;Dark_Aqua&gt;</h4>
      <h4 style={{ color: '#AA0000' }}>&lt;Dark_Red&gt;</h4>
      <h4 style={{ color: '#AA00AA' }}>&lt;Dark_Purple&gt;</h4>
      <h4 style={{ color: '#FFAA00' }}>&lt;Gold&gt;</h4>
      <h4 style={{ color: '#AAAAAA' }}>&lt;Gray&gt;</h4>
      <h4 style={{ color: '#555555' }}>&lt;Dark_Gray&gt;</h4>
      <h4 style={{ color: '#5555FF' }}>&lt;Blue&gt;</h4>
      <h4 style={{ color: '#55FF55' }}>&lt;Green&gt;</h4>
      <h4 style={{ color: '#55FFFF' }}>&lt;Aqua&gt;</h4>
      <h4 style={{ color: '#FF5555' }}>&lt;Red&gt;</h4>
      <h4 style={{ color: '#FF55FF' }}>&lt;Light_Purple&gt;</h4>
      <h4 style={{ color: '#FFFF55' }}>&lt;Yellow&gt;</h4>
      <h4 style={{ color: '#000000' }}>&lt;Black&gt;</h4>
      <h4 style={{ color: '#FFFFFF' }}>&lt;White&gt;</h4>
      <h4 style={{ textDecoration: 'underline' }}>&lt;Underlined&gt;</h4>
      <h4 style={{ fontWeight: '600' }}>&lt;Bold&gt;</h4>
      <h4 style={{ fontStyle: 'italic' }}>&lt;Italic&gt;</h4>
      <h4 style={{ textDecoration: 'line-through' }}>&lt;Strikethrough&gt;</h4>
      <h4>&lt;Obfuscated&gt;</h4>
      <h4>&lt;Reset&gt;</h4>
    </div>
  );

  return (
    <nav className={!toggleHamburger ? 'navbar active' : 'navbar'}>
      <img 
        onClick={() => handleLogoClick()}
        onMouseEnter={() => {
          if (activeLink !== 'editor') return;
          setIsColourPopupOpen(true);
        }}
        onMouseLeave={() => {
          setIsColourPopupOpen(false);
        }}
        src={logo} 
        alt="logo" 
        className={`navbar-logo ${isColourPopupOpen && activeLink === 'editor' ? 'navbar-logo-animate' : ''}`}/>
      {isColourPopupOpen && activeLink === 'editor' && colourPopup}
      {/* Add this to include an image in the right side of the navbar */}
      {/* <img className="partner-favicon" /> */}
      <h2 className="partner-favicon" onClick={() => redirectToPage('news')}>
        Moving from v3?
        <p>Convert your panels now</p>
      </h2>
      <div className={toggleHamburger ? 'navbar-toggle' : 'navbar-toggle active'} onClick={handleToggleHamburger}>
        <span className="icon-bar"></span>
        <span className="icon-bar"></span>
        <span className="icon-bar"></span>
      </div>
      <ul className={toggleHamburger ? 'navbar-list' : 'navbar-list active'}>
        <li className={activeLink === 'download' ? 'active-link navbar-item' : 'navbar-item'}>
          <Link onClick={handleToggleHamburger} to={EXTERNAL_LINKS.Download} target="_blank" rel="noreferrer" className="navbar-link" title="Download">
            <FaDownload size={25}/>
          </Link>
        </li>
        <li className={activeLink === 'docs' ? 'active-link navbar-item' : 'navbar-item'}>
          <Link onClick={handleToggleHamburger} to={EXTERNAL_LINKS.Docs} className="navbar-link" title="Documentation">
            <FaBook size={25}/>
          </Link>
        </li>
        <li className={activeLink === 'editor' ? 'active-link navbar-item' : 'navbar-item'} onClick={() => redirectToPage('editor')}>
          <Link onClick={handleToggleHamburger} to="/editor" className="navbar-link" title="Editor">
            <FaEdit size={25} />
          </Link>
        </li>
        <li className={activeLink === 'templates' ? 'active-link navbar-item' : 'navbar-item'} onClick={() => redirectToPage('templates')}>
          <Link onClick={handleToggleHamburger} to="/templates" className="navbar-link" title="Templates">
            <FaLayerGroup size={25} />
          </Link>
        </li>
        <div className="navbar-link-border" />
        <li className={activeLink === 'github' ? 'active-link navbar-item' : 'navbar-item'}>
          <Link onClick={handleToggleHamburger} to={EXTERNAL_LINKS.GitHub} target="_blank" rel="noreferrer" className="navbar-link" title="GitHub">
            <FaGithub size={30}/>
          </Link>
        </li>
        <li className={activeLink === 'discord' ? 'active-link navbar-item' : 'navbar-item'}>
          <Link onClick={handleToggleHamburger} to={EXTERNAL_LINKS.Discord} target="_blank" rel="noreferrer" className="navbar-link" title="Discord">
            <FaDiscord size={30}/>
          </Link>
        </li>
      </ul>
    </nav>
  );
}